import { render, staticRenderFns } from "./Reportings.vue?vue&type=template&id=5240a8d6&"
import script from "./Reportings.vue?vue&type=script&lang=js&"
export * from "./Reportings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports